import { Input, Tooltip } from "antd";
import SearchIcon from "@mui/icons-material/Search";
// import "./search.css";
import { useTranslation } from "react-i18next";

interface button {
  value: any;
  onEnter?: any;
  onChange?: any;
  onKeyPress?: any;
  disabled?: boolean
}

export const Search = ({ value, onEnter, onChange, onKeyPress, disabled }: button) => {

  const [t] = useTranslation("common");

  return (
    <>
      <Input
        size={"large"}
        placeholder={`${t("search")}`}
        disabled={disabled}
        suffix={
          <Tooltip>
            <SearchIcon
              style={{ fontSize: "20px", color: "#BDBDBD", cursor: "pointer" }}
              onClick={onEnter}
            />
          </Tooltip>
        }
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        onPressEnter={onEnter}
      />
    </>
  );
};
